import React from 'react';
import fortinetIcon from '../../../../assets/img/desktop/fortinet-logo.png';
import sonicwallIcon from '../../../../assets/img/desktop/sonicwall-logo.png';
import fortinetLogo from '../../../../assets/img/desktop/fortinet-logo.png';
import sonicwallLogo from '../../../../assets/img/desktop/sonicwall-logo.png';
import './CMSeguridadPerimetral.css';

function CMSeguridadPerimetral() {

    return (
        <main id="CMSeguridadPerimetral">
            <section id="CMSP-c1">
                <h2>Seguridad Perimetral</h2>
                <ul>
                    <li>Inicio</li>
                    <li>/</li>
                    <li>Servicios</li>
                    <li>/</li>
                    <li>Ciberseguridad</li>
                    <li>/</li>
                    <li>Seguridad Perimetral</li>
                </ul>
            </section>
            <section id="CMSP-c2">
                <div id="CMSP-c2__text">
                    <h1>Protección Perimetral para su Red Empresarial</h1>
                    <p>La seguridad perimetral es la primera línea de defensa contra amenazas cibernéticas. Proteja su infraestructura de red con firewalls de próxima generación que ofrecen visibilidad, control y protección avanzada contra ataques sofisticados.</p>
                </div>
            </section>
            <section id="CMSP-c3">
                <div className="CMSP-service-card">
                    <div className="CMSP-service-card__icon">
                        <img src={fortinetIcon} alt="Fortinet Icon" />
                    </div>
                    <h3>Fortinet</h3>
                    <p>Fortinet FortiGate ofrece firewalls de próxima generación (NGFW) que combinan funciones de firewall tradicionales con capacidades avanzadas de inspección profunda de paquetes (DPI), prevención de intrusiones (IPS), filtrado de aplicaciones y protección contra amenazas. La plataforma FortiGate utiliza FortiGuard Labs para proporcionar protección en tiempo real contra malware, exploits y ataques dirigidos.</p>
                    <div className="CMSP-service-card__logo">
                        <img src={fortinetLogo} alt="Fortinet Logo" />
                    </div>
                </div>
                <div className="CMSP-service-card">
                    <div className="CMSP-service-card__icon">
                        <img src={sonicwallIcon} alt="SonicWall Icon" />
                    </div>
                    <h3>SonicWall</h3>
                    <p>SonicWall ofrece soluciones de seguridad de red de próxima generación diseñadas para proteger a las organizaciones contra amenazas avanzadas. Los firewalls SonicWall TZ y NSa Series proporcionan inspección profunda de paquetes, protección contra malware, filtrado de contenido web y control de aplicaciones. La tecnología Capture Advanced Threat Protection (ATP) utiliza análisis de sandbox en la nube para detectar y bloquear amenazas desconocidas.</p>
                    <div className="CMSP-service-card__logo">
                        <img src={sonicwallLogo} alt="SonicWall Logo" />
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CMSeguridadPerimetral;

